import { IFilter } from "../types/type"
import { IProject } from "../types/project"

/**
 * Build filters list
 */
export const projectFilters = (projects: IProject[]): IFilter[] => {
  const list: string[] = []

  // Push all filters
  projects.forEach(({ role, cardView }) => {
    if (role && cardView) {
      list.push(...role)
    }
  })

  // Remove duplicates
  const filteredList = list.filter(
    (item, i) => list.indexOf(item) === i
  )

  // Add number of results for each filter
  const filtersWithResults = filteredList.map((filter, i) => {
    return {
      name: filter,
      results: list.filter(item => item === filter).length,
    }
  })

  return filtersWithResults
}
